import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class PatchOrderDateInfoDto {
}
__decorate([
    ApiPropertyOptional({
        type: () => String,
        format: 'date-time',
        description: 'order acknowledgment time (from dashboard)',
        example: '2022-05-05T08:49:54.645+0000',
    }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], PatchOrderDateInfoDto.prototype, "orderConfirmedAt", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        format: 'date-time',
        description: 'arrival acknowledgment time (from dashboard)',
        example: '2022-05-05T08:49:54.645+0000',
    }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], PatchOrderDateInfoDto.prototype, "arrivalConfirmedAt", void 0);
//# sourceMappingURL=PatchOrderDateInfoDto.js.map